import React, { Suspense, useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HOME, ADMIN, LOGIN } from "./pathConstants";
import { PathConstants } from "./pathConstants";
import { ComponentLazy } from "../components";
import AllapattahLocalGuideService from "../services/alg.service";

const AppRouter: React.FC = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const getAdminProfile = async () => {
      await AllapattahLocalGuideService.getAdminProfile(setIsLoggedIn);
      setIsLoading(false);
    };

    if (
      !isLoggedIn &&
      (location.pathname === PathConstants.ADMIN ||
        location.pathname === PathConstants.LOGIN)
    ) {
      getAdminProfile();
    } else {
      setIsLoading(false);
    }
  }, [location.pathname, isLoggedIn]);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      {isLoading ? (
        // TODO: We need to show a loading screen here
        <div>Loading...</div>
      ) : (
        <Routes>
          <Route
            path="*"
            element={<Navigate to={PathConstants.HOME} replace />}
          />
          <Route
            path={PathConstants.HOME}
            element={<ComponentLazy component={HOME} />}
          />
          <Route
            path={PathConstants.ADMIN}
            element={
              isLoggedIn ? (
                <ComponentLazy component={ADMIN} />
              ) : (
                <Navigate to={PathConstants.LOGIN} replace />
              )
            }
          />
          <Route
            path={PathConstants.LOGIN}
            element={
              isLoggedIn ? (
                <Navigate to={PathConstants.ADMIN} replace />
              ) : (
                <ComponentLazy component={LOGIN} />
              )
            }
          />
        </Routes>
      )}
    </Suspense>
  );
};

export default AppRouter;
